import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { userStateAtom } from "../atoms/userStateAtom";
import axios from "axios";
import { usedIdAtom } from "../atoms/useIdAtom";

const Header = () => {
  const [userState, setUserState] = useRecoilState<any>(userStateAtom);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const [usedIds, setUsedIds] = useRecoilState(usedIdAtom);
  const userName = userState.userData.name;
  const userId = userState.userData.userIdphp;
  const userGradeNumber = userState.userData.grade;

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const move2UsedId = () => {
    navigate("/fun_learning/usedId");
  };

  const onNoticeClick = () => {
    navigate("/fun_learning/");
  };

  const onCooperateClick = () => {
    navigate("/fun_learning/cooperate");
  };

  const onSuccessedWordsClick = () => {
    navigate("/fun_learning/successedwords");
  };

  const onVocaClick = () => {
    navigate("/fun_learning/vocatoktok");
  };
  const onSentenceClick = () => {
    navigate("/fun_learning/sentencetoktok");
  };
  const onFunlearningAloneClick = () => {
    navigate("/fun_learning/funlearningalone");
  };
  const onLiteracyLearningClick = () => {
    navigate("/fun_learning/literacylearning");
  };

  const onCreateLearningClick = () => {
    navigate("/fun_learning/createlearning");
  };

  const onLevelLearningClick = () => {
    navigate("/fun_learning/levellearning"); //추후 개발
  };
  const onMyInfoClick = () => {
    navigate("/fun_learning/myinfo");
  };

  const goToComingSoon = () => {
    navigate("/fun_learning/comingsoon");
  };

  const onNoticeClickMobile = () => {
    navigate("/fun_learning/");
    setIsSidebarOpen(!isSidebarOpen);
  };

  const onCooperateClickMobile = () => {
    navigate("/fun_learning/cooperate");
    setIsSidebarOpen(!isSidebarOpen);
  };

  const onSuccessedWordsClickMobile = () => {
    navigate("/fun_learning/successedwords");
    setIsSidebarOpen(!isSidebarOpen);
  };

  const onVocaClickMobile = () => {
    navigate("/fun_learning/vocatoktok");
    setIsSidebarOpen(!isSidebarOpen);
  };
  const onSentenceClickMobile = () => {
    navigate("/fun_learning/sentencetoktok");
    setIsSidebarOpen(!isSidebarOpen);
  };
  const onFunlearningAloneClickMobile = () => {
    navigate("/fun_learning/funlearningalone");
    setIsSidebarOpen(!isSidebarOpen);
  };
  const onLiteracyLearningClickMobile = () => {
    navigate("/fun_learning/literacylearning");
    setIsSidebarOpen(!isSidebarOpen);
  };

  const onCreateLearningClickMobile = () => {
    navigate("/fun_learning/createlearning");
    setIsSidebarOpen(!isSidebarOpen);
  };

  const onLevelLearningClickMobile = () => {
    navigate("/fun_learning/levellearning"); //추후 개발
    setIsSidebarOpen(!isSidebarOpen);
  };
  const onMyInfoClickMobile = () => {
    navigate("/fun_learning/myinfo");
    setIsSidebarOpen(!isSidebarOpen);
  };

  const goToComingSoonMobile = () => {
    navigate("/fun_learning/comingsoon");
    setIsSidebarOpen(!isSidebarOpen);
  };

  const deleteAll = async () => {
    await axios.get(
      "https://chamstudyland.com/api/fun_learning/delete_usedId.php"
    );
    fetchData();
  };

  const fetchData = async () => {
    const res = await axios.get(
      "https://chamstudyland.com/api/fun_learning/get_usedId.php"
    );
    const idList = res.data;
    setUsedIds(idList);
  };

  return (
    <>
      <nav className="bg-white dark:border-gray-200 dark:bg-gray-900 border-b-2 shadow-lg dark:border-none">
        <div
          className="absolute bg-slate-200 dark:bg-gray-800 text-white w-56 min-h-screen overflow-y-auto transition-transform transform z-50"
          id="sidebar"
          style={{
            transform: isSidebarOpen ? "translateX(0)" : "translateX(-100%)",
          }}
        >
          <div className="p-4">
            <h1 className="text-2xl font-semibold text-blue-600">Menu</h1>
            <ul className="mt-4">
              <li className="mb-2">
                <div className="block text-blue-500 hover:text-green-500 dark:text-blue-200">
                  <button onClick={onNoticeClickMobile}>공지사항</button>
                </div>
              </li>
              <li className="mb-2">
                <div className="block text-blue-500 hover:text-orange-500 dark:text-blue-200">
                  <button onClick={onVocaClickMobile}>보카톡톡</button>
                </div>
              </li>
              <li className="mb-2">
                <div className="block text-blue-500 hover:text-purple-500 dark:text-blue-200">
                  <button onClick={onSentenceClickMobile}>문장톡톡</button>
                </div>
              </li>
              <li className="mb-2">
                <div className="block text-blue-500 hover:text-blue-500 dark:text-blue-200">
                  <button onClick={onCooperateClickMobile}>협력학습실</button>
                </div>
              </li>
              <li className="mb-2">
                <div className="block text-blue-500 hover:text-teal-500 dark:text-blue-200">
                  <button onClick={onFunlearningAloneClickMobile}>
                    즐거운 학습
                  </button>
                </div>
              </li>
              <li className="mb-2">
                <div className="block text-blue-500 hover:text-amber-500 dark:text-blue-200">
                  <button onClick={onLiteracyLearningClickMobile}>
                    기초학습
                  </button>
                </div>
              </li>
              <li className="mb-2">
                <div className="block text-blue-500 hover:text-pink-500 dark:text-blue-200">
                  <button onClick={onSuccessedWordsClickMobile}>
                    성공한 학습
                  </button>
                </div>
              </li>
              <li className="mb-2">
                <div className="block text-blue-500 hover:text-indigo-500 dark:text-blue-200">
                  <button onClick={onCreateLearningClickMobile}>
                    창작학습
                  </button>
                </div>
              </li>
              <li className="mb-2">
                <div className="block text-blue-500 hover:text-cyan-500 dark:text-blue-200">
                  <button onClick={onMyInfoClickMobile}>내 정보</button>
                </div>
              </li>
              {userGradeNumber === "14" || userGradeNumber === "15" ? (
                <li className="mb-2">
                  <div className="block text-blue-500 hover:text-orange-500 dark:text-blue-200">
                    <button onClick={deleteAll}>reset</button>
                  </div>
                </li>
              ) : (
                ""
              )}
            </ul>
          </div>
        </div>
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">
            보카톡톡 Fun Learning
          </span>

          <button
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-controls="sidebar"
            aria-expanded={isSidebarOpen ? "true" : "false"}
            onClick={toggleSidebar}
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
          <div className="hidden w-full md:block md:w-auto" id="navbar-default">
            <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
              {userState.userData.grade === "15" && (
                <li>
                  <div
                    className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white hover:text-green-500 md:dark:text-blue-200"
                    aria-current="page"
                  >
                    <button onClick={move2UsedId}>사용된ID</button>
                  </div>
                </li>
              )}
              <li>
                <div
                  className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white hover:text-green-500 md:dark:text-blue-200"
                  aria-current="page"
                >
                  <button onClick={onNoticeClick}>공지사항</button>
                </div>
              </li>
              <li>
                <div
                  className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white hover:text-orange-500 md:dark:text-blue-200"
                  aria-current="page"
                >
                  <button onClick={onVocaClick}>보카톡톡</button>
                </div>
              </li>
              <li>
                <div
                  className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white hover:text-purple-500 md:dark:text-blue-200"
                  aria-current="page"
                >
                  <button onClick={onSentenceClick}>문장톡톡</button>
                </div>
              </li>
              <li>
                <div
                  className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white hover:text-blue-500 md:dark:text-blue-200"
                  aria-current="page"
                >
                  <button onClick={onCooperateClick}>협력학습실</button>
                </div>
              </li>
              <li>
                <div
                  className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white hover:text-teal-500 md:dark:text-blue-200"
                  aria-current="page"
                >
                  <button onClick={onFunlearningAloneClick}>즐거운 학습</button>
                </div>
              </li>
              <li>
                <div
                  className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white hover:text-amber-500 md:dark:text-blue-200"
                  aria-current="page"
                >
                  <button onClick={onLiteracyLearningClick}>기초학습</button>
                </div>
              </li>
              <li>
                <div
                  className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white hover:text-pink-500 md:dark:text-blue-200"
                  aria-current="page"
                >
                  <button onClick={onSuccessedWordsClick}>성공한 학습</button>
                </div>
              </li>
              <li>
                <div
                  className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white hover:text-indigo-500 md:dark:text-blue-200"
                  aria-current="page"
                >
                  <button onClick={onCreateLearningClick}>창작학습</button>
                </div>
              </li>
              <li>
                <div
                  className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white hover:text-cyan-500 md:dark:text-blue-200"
                  aria-current="page"
                >
                  <button onClick={onMyInfoClick}>내 정보</button>
                </div>
              </li>
              {userGradeNumber === "14" || userGradeNumber === "15" ? (
                <li>
                  <div
                    className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white hover:text-orange-500 md:dark:text-blue-200"
                    aria-current="page"
                  >
                    <button onClick={deleteAll}>reset</button>
                  </div>
                </li>
              ) : (
                ""
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
